import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const TableOfContentsParagraphLoadable = loadable(
  () => import('./TableOfContentsParagraph'),
  {
    resolveComponent: components => components.TableOfContentsParagraph
  }
);

export const TableOfContentsParagraph = WithLazyHydration(
  TableOfContentsParagraphLoadable,
  {
    name: 'TableOfContentsParagraph'
  }
);
